var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 1C4 0.516751 4.39175 0.125 4.875 0.125H13.625C14.1082 0.125 14.5 0.516751 14.5 1V13.25C14.5 13.9462 14.2234 14.6139 13.7312 15.1062C13.2389 15.5984 12.5712 15.875 11.875 15.875H4.875C4.39175 15.875 4 15.4832 4 15C4 14.5168 4.39175 14.125 4.875 14.125H11.875C12.1071 14.125 12.3296 14.0328 12.4937 13.8687C12.6578 13.7046 12.75 13.4821 12.75 13.25V1.875H4.875C4.39175 1.875 4 1.48325 4 1ZM6.88128 4.75628C7.22299 4.41457 7.77701 4.41457 8.11872 4.75628L10.7437 7.38128C11.0854 7.72299 11.0854 8.27701 10.7437 8.61872L8.11872 11.2437C7.77701 11.5854 7.22299 11.5854 6.88128 11.2437C6.53957 10.902 6.53957 10.348 6.88128 10.0063L8.01256 8.875H1.375C0.891751 8.875 0.5 8.48325 0.5 8C0.5 7.51675 0.891751 7.125 1.375 7.125H8.01256L6.88128 5.99372C6.53957 5.65201 6.53957 5.09799 6.88128 4.75628Z",
    fill: "#FDFDFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGo);
export default __webpack_public_path__ + "static/media/icon_go.6eb6c0de4c0fac0151ecea26e764b82c.svg";
export { ForwardRef as ReactComponent };